import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes.tsx';

// Loading component for Suspense fallback
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
  </div>
);

// Create router with error handling
const router = createBrowserRouter(
  routes.map(route => ({
    ...route,
    element: (
      <Suspense fallback={<LoadingSpinner />}>
        {route.element}
      </Suspense>
    ),
  }))
);

// Main router provider component
const RouterConfig: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default RouterConfig; 